import { useState, useEffect } from 'react';
import homePageService from '../../../services/homePageService';
import './AdminSlider.css';

const SECTION_LABELS = {
  welcome: 'Hoş Geldiniz',
  discover: 'Tarihi Keşfedin',
  cultural: 'Kültürel Miras',
  explore: 'Zaman Çizelgelerini Keşfedin',
};

const AdminTexts = () => {
  const [textData, setTextData] = useState(null);
  const [sideImages, setSideImages] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [editingSection, setEditingSection] = useState(null);
  const [editForm, setEditForm] = useState({ title: '', description: '', buttonUrl: '' });
  const [newImage, setNewImage] = useState(null);
  const [showAddForm, setShowAddForm] = useState(false);
  const [newSection, setNewSection] = useState({ key: '', title: '', description: '', buttonUrl: '', image: null });

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const content = await homePageService.getHomePageContent();
      if (content.textData) setTextData(content.textData);
      if (content.sideImages) setSideImages(content.sideImages);
    } catch { setError('Veriler yüklenemedi.'); }
    finally { setLoading(false); }
  };

  const handleEdit = (key) => {
    setEditingSection(key);
    setEditForm({ ...textData[key] });
    setNewImage(null);
    setShowAddForm(false);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => setNewImage(reader.result);
    reader.readAsDataURL(file);
  };

  const handleNewFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => setNewSection({ ...newSection, image: reader.result });
    reader.readAsDataURL(file);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    try {
      const updateData = { textData: { ...textData, [editingSection]: editForm } };
      if (newImage && sideImages) {
        updateData.sideImages = { ...sideImages, [editingSection]: newImage };
      }
      await homePageService.updateHomePageContent(updateData);
      setTextData({ ...textData, [editingSection]: editForm });
      if (newImage && sideImages) setSideImages({ ...sideImages, [editingSection]: newImage });
      setEditingSection(null);
      setNewImage(null);
      setSuccess('Bölüm güncellendi.');
    } catch { setError('Kaydetme başarısız.'); }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    if (!newSection.key || !newSection.title) { setError('Anahtar ve başlık zorunlu.'); return; }

    try {
      const updateData = {
        textData: { ...textData, [newSection.key]: { title: newSection.title, description: newSection.description, buttonUrl: newSection.buttonUrl } }
      };
      if (newSection.image && sideImages) {
        updateData.sideImages = { ...sideImages, [newSection.key]: newSection.image };
      }
      await homePageService.updateHomePageContent(updateData);
      setTextData({ ...textData, [newSection.key]: { title: newSection.title, description: newSection.description, buttonUrl: newSection.buttonUrl } });
      if (newSection.image && sideImages) setSideImages({ ...sideImages, [newSection.key]: newSection.image });
      setShowAddForm(false);
      setNewSection({ key: '', title: '', description: '', buttonUrl: '', image: null });
      setSuccess('Yeni bölüm eklendi.');
    } catch { setError('Kaydetme başarısız.'); }
  };

  const handleDelete = async (key) => {
    if (!window.confirm(`"${SECTION_LABELS[key] || key}" bölümünü silmek istediğinizden emin misiniz?`)) return;
    setError(''); setSuccess('');
    try {
      const newTextData = { ...textData };
      delete newTextData[key];
      const newSideImages = sideImages ? { ...sideImages } : {};
      delete newSideImages[key];
      await homePageService.updateHomePageContent({ textData: newTextData, sideImages: newSideImages });
      setTextData(newTextData);
      setSideImages(newSideImages);
      setSuccess('Bölüm silindi.');
    } catch { setError('Silme başarısız.'); }
  };

  if (loading) return <div className="admin-slider-empty">Yükleniyor...</div>;
  if (!textData) return <div className="admin-slider-empty">Veri bulunamadı.</div>;

  return (
    <div className="admin-slider">
      {success && <div className="admin-slider-success">{success}</div>}
      {error && <div className="admin-slider-error">{error}</div>}

      <div className="admin-slider-card">
        <div className="admin-slider-header">
          <h3>Metin Bölümleri ({Object.keys(textData).length})</h3>
          <button className="admin-slider-add-btn" onClick={() => { setShowAddForm(!showAddForm); setEditingSection(null); }}>+ Yeni Bölüm</button>
        </div>

        {/* Yeni Bölüm Formu */}
        {showAddForm && (
          <form className="admin-slider-form" onSubmit={handleAdd}>
            <h4>Yeni Metin Bölümü Ekle</h4>
            <div className="admin-slider-form-group">
              <label>Anahtar (İngilizce, boşluksuz, ör: "about")</label>
              <input type="text" value={newSection.key} onChange={(e) => setNewSection({ ...newSection, key: e.target.value.toLowerCase().replace(/\s/g, '') })} placeholder="about" />
            </div>
            <div className="admin-slider-form-group">
              <label>Başlık</label>
              <input type="text" value={newSection.title} onChange={(e) => setNewSection({ ...newSection, title: e.target.value })} />
            </div>
            <div className="admin-slider-form-group">
              <label>Açıklama</label>
              <textarea value={newSection.description} onChange={(e) => setNewSection({ ...newSection, description: e.target.value })} rows="4" style={{ width: '100%', padding: '0.5rem 0.75rem', backgroundColor: '#1f2937', border: '1px solid #4b5563', borderRadius: '0.375rem', color: '#fff', fontSize: '0.875rem', resize: 'vertical' }} />
            </div>
            <div className="admin-slider-form-group">
              <label>Buton URL</label>
              <input type="text" value={newSection.buttonUrl} onChange={(e) => setNewSection({ ...newSection, buttonUrl: e.target.value })} placeholder="https://..." />
            </div>
            <div className="admin-slider-form-group">
              <label>Bölüm Resmi</label>
              <input type="file" accept="image/*" onChange={handleNewFileChange} />
              {newSection.image && <img src={newSection.image} alt="Önizleme" className="admin-slider-preview" />}
            </div>
            <div className="admin-slider-form-actions">
              <button type="submit" className="admin-slider-btn-save">Ekle</button>
              <button type="button" className="admin-slider-btn-cancel" onClick={() => setShowAddForm(false)}>İptal</button>
            </div>
          </form>
        )}

        {/* Düzenleme Formu */}
        {editingSection && (
          <form className="admin-slider-form" onSubmit={handleSave}>
            <h4>Düzenle: {SECTION_LABELS[editingSection] || editingSection}</h4>
            <div className="admin-slider-form-group">
              <label>Başlık</label>
              <input type="text" value={editForm.title} onChange={(e) => setEditForm({ ...editForm, title: e.target.value })} />
            </div>
            <div className="admin-slider-form-group">
              <label>Açıklama</label>
              <textarea value={editForm.description} onChange={(e) => setEditForm({ ...editForm, description: e.target.value })} rows="4" style={{ width: '100%', padding: '0.5rem 0.75rem', backgroundColor: '#1f2937', border: '1px solid #4b5563', borderRadius: '0.375rem', color: '#fff', fontSize: '0.875rem', resize: 'vertical' }} />
            </div>
            <div className="admin-slider-form-group">
              <label>Buton URL</label>
              <input type="text" value={editForm.buttonUrl} onChange={(e) => setEditForm({ ...editForm, buttonUrl: e.target.value })} />
            </div>
            {sideImages && sideImages[editingSection] !== undefined && (
              <div className="admin-slider-form-group">
                <label>Bölüm Resmi</label>
                <img src={newImage || sideImages[editingSection]} alt="Mevcut" className="admin-slider-preview" />
                <input type="file" accept="image/*" onChange={handleFileChange} style={{ marginTop: '0.5rem' }} />
              </div>
            )}
            <div className="admin-slider-form-actions">
              <button type="submit" className="admin-slider-btn-save">Kaydet</button>
              <button type="button" className="admin-slider-btn-cancel" onClick={() => { setEditingSection(null); setNewImage(null); }}>İptal</button>
            </div>
          </form>
        )}

        {/* Liste */}
        <div style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          {Object.entries(textData).map(([key, value]) => (
            <div key={key} style={{ padding: '1rem', backgroundColor: '#374151', borderRadius: '0.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem' }}>
              {sideImages && sideImages[key] && (
                <img src={sideImages[key]} alt={key} style={{ width: '80px', height: '50px', objectFit: 'cover', borderRadius: '0.375rem', flexShrink: 0 }} />
              )}
              <div style={{ flex: 1 }}>
                <strong style={{ color: '#f3f4f6', fontSize: '0.9rem' }}>{SECTION_LABELS[key] || key}</strong>
                <p style={{ color: '#9ca3af', fontSize: '0.75rem', margin: '0.25rem 0 0 0' }}>{value.title}</p>
              </div>
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <button className="admin-slider-btn-edit" onClick={() => handleEdit(key)}>Düzenle</button>
                <button className="admin-slider-btn-delete" onClick={() => handleDelete(key)}>Sil</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminTexts;
